// @ts-nocheck
/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import React from "react";

/* Starter Custom Code - Start */
import translate from "@insite/client-framework/Translate";
/* Starter Custom Code - End */

interface OwnProps {
    title: string;
    orderNumber: string;
    isVmiOrderDetailsPage?: boolean;
    isVmiOrder?: boolean;
}

type Props = OwnProps;

const OrderDetailPageTypeLink: React.FunctionComponent<Props> = ({
    title,
    orderNumber,
    isVmiOrderDetailsPage,
    isVmiOrder,
}) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: isVmiOrderDetailsPage ? "VmiOrderDetailsPage" : "OrderDetailsPage",
            overrideTitle: title,
            queryString: isVmiOrderDetailsPage
                ? `orderNumber=${orderNumber}`
                : isVmiOrder
                ? `orderNumber=${orderNumber}&isVmiOrder=true`
                : `orderNumber=${orderNumber}`,
            linkAccessibleText: translate("See Order Details"), // Starter Custom Code
        },
    });
};

export default OrderDetailPageTypeLink;
